import React from 'react';

export default function PhoneIcon() {
  return (
    <svg width="256px" height="256px" viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Artboard 3</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Artboard-3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M54,0 L201.333333,0 C201.885618,-1.01453063e-16 202.333333,0.44771525 202.333333,1 L202.333333,255 C202.333333,255.552285 201.885618,256 201.333333,256 L54,256 C53.4477153,256 53,255.552285 53,255 L53,1 C53,0.44771525 53.4477153,1.01453063e-16 54,0 Z M127.666667,240.010667 C133.554667,240.010667 138.333333,235.232 138.333333,229.344 C138.333333,223.456 133.554667,218.677333 127.666667,218.677333 C121.778667,218.677333 117,223.456 117,229.344 C117,235.232 121.778667,240.010667 127.666667,240.010667 Z M74.3333333,42.6666667 L74.3333333,202.666667 L181,202.666667 L181,42.6666667 L74.3333333,42.6666667 Z"
          id="Combined-Shape"
          fill="currentColor"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  );
}
